export const MAXIMUM_ENQUIRY_HANDLERS = 2
